<template>
    <div>
        <WebDataRocks
            v-if="pivotDisplay"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks'
import SearchClient from '../../../activity_management/clients/components/SearchClient'

export default {
    name: 'EvolutionPivotFirm',

    components: {
        WebDataRocks,
        SearchClient,
    },

    data() {
        return {
            pivotDisplay: false,
            pivotConfig: {
                dataSource: {},
                slice: {},
                options: {
                    grid: {
                        type: 'classic',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'columns',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: '',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 0,
                        maxSymbols: 20,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        showPivot() {
            this.pivotDisplay = true
        },

        hidePivot() {
            this.pivotDisplay = false
        },

        updateKey() {
            this.key = Date.now()
        },

        async getData() {
            try {
                const response = await axios.get(
                    `/dashboard/evolution/pivot/${this.year}`
                )
                this.pivotData = response.data.data
                this.setInitialReport()
                this.showPivot()
            } catch (error) {
                console.log(error)
            }
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                rows: [
                    { uniqueName: 'Date.Month' },
                    { uniqueName: 'Activité', sort: 'asc' },
                ],
                columns: [{ uniqueName: 'An', sort: 'desc' }],
                reportFilters: [{ uniqueName: 'Cabinet' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.updateKey()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
